import { createSlice } from "@reduxjs/toolkit";

const initialState = 
{
  currentYear: 0,
};


export const yearSlice = createSlice(
  {
    name: "year",
    
    initialState,

    reducers: 
    {
      setCurrentYear: (state, action) =>
      {
        state.currentYear = action.payload;
      }
    },
  }
);
  
// Aktionen und Reducer extrahieren
const { actions, reducer } = yearSlice

// Einzelaktionen aus den Actions herausziehen
export const { setCurrentYear } = actions

// Und dann schieben wir noch den Reducer heraus
export default reducer